module.exports = __webpack_public_path__ + "static/media/SettingsActive.00a5c763.png";